import Box from "@mui/material/Box";
import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Grid } from "@mui/material";

export const StyledGrid = styled(Grid)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 100%;
  gap: 10px;
  grid-auto-flow: dense;
  
  .wrapper div:nth-child(1) {
    grid-row: 1 / 4;
    background-color: #ffa94d;
    height: 100%;
  }
`

export const StyledAnalystDashSummary = styled(Box)`
  width: 90%;

  .card-content {
    display: flex;
    justify-content: space-between;
    color: #00ffff;
    font-weight: 500;
    font-size: 12px;
    align-items: center;

    .count {
      background: #3e3e51;
      padding: 6px 10px;
      border-radius: 25px;
    }

    .left-icon {
      padding-right: 14px;
    }
    .circle {
      padding-right: 16px;
      border-radius: 12px;
      margin-right: 16px;
    }

    .circle-7500C0 {
      background-color: #7500c0;
    }
    .circle-DA9EFF {
      background-color: #da9eff;
    }
    .circle-64FF50 {
      background-color: #64ff50;
    }
    .circle-FF7800 {
      background-color: #ff7800;
    }
  }
`;

export const IncidentsToolBar = styled('div')`
  margin-top: 1em;
  display: flex;
  flex-wrap: wrap;
`;

export const IncidentsToolbarInner = styled('div')`
  display: flex;
  flex-direction: row;
  flex: 0 0 66%;
  max-width: 65%;
  justify-content: space-between;

  div:first-child {
    padding-right: 1em;
    border-radius: 46px !important;
  }
`;

export const StyledAnalystDash = styled.div`
  .all-filters {
    margin-left: 12px;
  }

  .analystDash-cases-filters {
    display: flex;
    justify-content: space-between;
  }

  .analystDash-cases-toolbar {
    margin-top: 1em;
    white-space: pre;
  }

  @media ${deviceSpec.isDesktop} {
    .analystDash-cases-toolbar {
    }
  }

  @media ${deviceSpec.isTablet} {
    .analystDash-cases-toolbar {
      margin-top: 0px;
      grid-template-columns: 1fr;
      padding: 0px 20px;
      margin-bottom: 0;
    }

    .rs-picker-toggle {
      font-size: 13px;
    }
    
    .filter-by {
      top: 2%;
      position: absolute;
      right: 35px;
    }
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  
  @media ${deviceSpec.isTablet} {
    :not(:first-child) {
      margin-top: 1em;
    }
    align-items: start;
    flex-direction: column;
  }
`